import { timelineItemClasses } from '@mui/lab';
export const timelineWrapperStyle = {
    [`& .${timelineItemClasses.root}:before`]: {
        flex: 0,
        padding: 0,
    },
};
export const timeLineSeparatorStyle = {
    mt: 1,
    mb: -1,
};
export const timelineDotStyle = {
    margin: '1px 0',
    padding: '2px',
    opacity: 0.6,
};
export const timelineDotWarningStyle = (color) => (Object.assign(Object.assign({}, timelineDotStyle), { opacity: 1, background: color }));
